import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const ContainerOver = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
    }
`
export const Container = styled(Box)`
    width: 740px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 1308.9px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 706px;
    }
`

export const Content = styled(Box)<{ active: boolean }>`
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    width: 116px;
    height: 29px;
    border-radius: 42px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 209px;
        height: 64px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 173px;
        height: 64px;
        justify-content: center;
    }
`
export const ContentTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 30px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`
